import React from 'react';
import { NumberTextField } from '../BuildingBlocks/Form/NumberTextField';
import { useMobile } from '../../hooks/useMobile';
import Typography from '@material-ui/core/Typography/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme: any) => ({
  text: {
    fontWeight: 700,
    color: theme.palette.brand.greenDark,
  },
}));

interface IAverageUnitPerPrice {
  register: any;
  errors?: any;
}
export default function AverageUnitPerPrice({
  register,
  errors,
}: IAverageUnitPerPrice) {
  const mobile = useMobile();
  const classes = useStyles({ mobile });

  return (
    <>
      <Typography variant={'h6'} gutterBottom className={classes.text}>
        What is your average unit sale price?
      </Typography>
      <NumberTextField
        errors={errors}
        label={'Average unit sale price'}
        name={'averageUnitPerPrice'}
        TextFieldProps={{
          ...register('averageUnitPerPrice', {
            required: {
              value: true,
              message: 'This field is required.',
            },
          }),
        }}
      />
    </>
  );
}
